import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { initGA, resolveGa4MeasurementId, trackPageView } from '../analytics';

/** Loads GA4 when a measurement ID is configured; tracks SPA page views. */
export default function Ga4Init() {
  const { settings: site } = useSiteSettings();
  const location = useLocation();

  useEffect(() => {
    const id = resolveGa4MeasurementId(site);
    if (!id) return;
    if (initGA(id)) {
      const path = `${location.pathname}${location.search}${location.hash}`;
      trackPageView(path);
    }
  }, [site, location.pathname, location.search, location.hash]);

  // Global JS error → GA4 exception event (fires only after GA4 is initialised).
  useEffect(() => {
    const handleError = (event) => {
      if (typeof window.gtag !== 'function') return;
      window.gtag('event', 'exception', {
        description: String(event?.message || event?.reason || 'Unknown error').slice(0, 150),
        fatal: false,
      });
    };
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleError);
    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleError);
    };
  }, []);

  return null;
}
